import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityAppNetCallG2OverviewVO } from '../Type/PackEntityAppNetCallG2OverviewVO'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询应用当前的音视频通话2.0总览信息
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 应用id
 * @param {string} [data.cid] 企业id
 */

export function funcnetcallG2overview(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityAppNetCallG2OverviewVO>
export function funcnetcallG2overview(
	data: DataModel,
	options?: IRequestOptions,
): Promise<
	PackEntityAppNetCallG2OverviewVO extends { msg: unknown } ? PackEntityAppNetCallG2OverviewVO['msg'] : undefined
>
export function funcnetcallG2overview(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/func/netcallG2/overview', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
